var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.953,
    height: 20.417,
    viewBox: "0 0 21.953 20.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2047",
    "data-name": "Group 2047",
    transform: "translate(634.85 184.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    "data-name": "Path 3433",
    d: "M-623.936-180.1a11.535,11.535,0,0,1,3.39.476.349.349,0,0,0,.4-.1c1.566-1.575,3.14-3.141,4.7-4.718.151-.152.23-.148.372,0,.342.364.7.716,1.059,1.06.131.124.112.19-.006.307q-2.41,2.4-4.811,4.807-7,7-14,14.008c-.159.159-.239.161-.39,0q-.494-.532-1.027-1.026c-.157-.146-.129-.222.008-.357q1.768-1.754,3.523-3.519c.205-.205.2-.2-.025-.364a14.808,14.808,0,0,1-4.041-4.121.262.262,0,0,1-.012-.346,13.975,13.975,0,0,1,7.984-5.739A10.837,10.837,0,0,1-623.936-180.1Zm.083,1.962a12.246,12.246,0,0,0-1.235.077c-.145.018-.289.039-.433.065a11.949,11.949,0,0,0-6.846,4.054.169.169,0,0,0,0,.269,13.913,13.913,0,0,0,3.152,2.779.181.181,0,0,0,.273-.033q.686-.7,1.386-1.386a.28.28,0,0,0,.084-.3,2.687,2.687,0,0,1-.023-1.1,2.93,2.93,0,0,1,3.511-2.383.278.278,0,0,0,.289-.077c.529-.536,1.064-1.066,1.6-1.6.04-.041.117-.076.091-.144s-.106-.048-.164-.06A9.456,9.456,0,0,0-623.853-178.141Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    d: "M-457.073-25.018c.566-.561,1.1-1.085,1.622-1.611a.232.232,0,0,1,.212-.053,9.852,9.852,0,0,0,6.831-1.915,13.574,13.574,0,0,0,2.566-2.371.226.226,0,0,0-.008-.361,13.6,13.6,0,0,0-2.428-2.149c-.158-.108-.164-.17-.027-.3.388-.372.767-.754,1.142-1.14a.167.167,0,0,1,.268-.023,14.466,14.466,0,0,1,3.515,3.619.217.217,0,0,1,.01.285,13.8,13.8,0,0,1-8.475,6.111,10.889,10.889,0,0,1-5-.023C-456.905-24.965-456.961-24.985-457.073-25.018Z",
    transform: "translate(-169.574 -142.661)",
    fill: "#737373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.282747afb2596b9f492954bbefcf22c0.svg";
export { ForwardRef as ReactComponent };